'use client';

import React, { useCallback } from 'react';
import { Button, notification } from 'antd';
import useNewBuildNotifier from '@/hooks/useNewBuildNotifier';

const NewBuildNotifier = () => {
  const [api, contextHolder] = notification.useNotification();

  const handleNewBuild = useCallback(
    ({ dismiss }) => {
      api.info({
        key: 'new-build-available',
        placement: 'bottomRight',
        duration: 0,
        message: 'New version available',
        description: 'A newer build is live. Refresh to load the latest updates.',
        btn: (
          <Button
            type="primary"
            size="small"
            onClick={() => {
              window.location.reload();
            }}
          >
            Refresh
          </Button>
        ),
        onClose: dismiss,
      });
    },
    [api],
  );

  useNewBuildNotifier({ onNewBuild: handleNewBuild });

  return contextHolder;
};

export default NewBuildNotifier;
